const moment = require('moment')
require('moment/locale/id')

export default (value) => 
  moment(value).format('LLLL')